import { Box, Stack, Text } from "@chakra-ui/react";
import type { ReactNode } from "react";
import type {
  MarketDialogueQuestionDto,
  ReceivedMarketDialogueAnswerDto,
} from "../../autogen/bff-api";
import { GivenAnswer } from "./GivenAnswer";

interface Props {
  questions: MarketDialogueQuestionDto[];
  answers: ReceivedMarketDialogueAnswerDto[];
  empty: ReactNode;
  answerMaxHeight?: string;
}

export const TakenForwardAnswers = ({
  questions,
  answers,
  empty,
  answerMaxHeight,
}: Props) => {
  const marked = questions
    .map((question, index) => ({
      question,
      number: index + 1,
      answers: answers.flatMap((answer) =>
        answer.answers
          .filter((given) => given.questionId === question.id && given.marked)
          .map((given) => ({ supplierName: answer.supplierName, given })),
      ),
    }))
    .filter((entry) => entry.answers.length > 0);

  if (marked.length === 0) return <Text color="smMuted">{empty}</Text>;
  return (
    <Stack spacing="5">
      {marked.map(({ question, number, answers: replies }) => (
        <Box key={question.id}>
          <Text fontWeight="medium" whiteSpace="pre-wrap" mb="2">
            {number}. {question.text}
          </Text>
          <Stack
            spacing="3"
            pl="3"
            borderLeftWidth="3px"
            borderColor="smPrimary"
          >
            {replies.map(({ supplierName, given }) => (
              <Box key={supplierName}>
                <Text fontSize="sm" fontWeight="semibold">
                  {supplierName}
                </Text>
                <GivenAnswer
                  question={question}
                  given={given}
                  maxHeight={answerMaxHeight}
                />
              </Box>
            ))}
          </Stack>
        </Box>
      ))}
    </Stack>
  );
};
